import serverApiV2Instance from "../services/serverApiV2Instance";

export const trackPages = async (visitedPage) => await serverApiV2Instance.post('/track-page-visit',{visitedPage})